import { workSheetConstants } from '../../_constants';

const initialState = { getWorkSheetDetailsLoading: true, data: '', error: false };

export function getWorkSheetDetailsReducer(state = initialState, action) {
    
    switch (action.type) {
        case workSheetConstants.REQUEST_GET_WORKSHEET_DETAILS:
            return {
                getWorkSheetDetailsLoading: true,
                data: '',
                error: false
            };
        case workSheetConstants.RECEIVE_GET_WORKSHEET_DETAILS:
            return {
                getWorkSheetDetailsLoading: false,
                data: action.getWorkSheetDetails,
                error: false
            };
        case workSheetConstants.GET_WORKSHEET_DETAILS_ERROR:
            return {
                getWorkSheetDetailsLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/workSheet/getWorksheetDetails.reducer.js